import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import {
	ACTIVE_MEMBER_ROLES,
	INVITED_MEMBER_ROLES,
	GroupMember,
	UserRole,
} from '@front-app/services/UserApi/UserModel';
import cloneDeep from 'clone-deep';

export const isActiveMember = ({ groupRole }: GroupMember): boolean => ACTIVE_MEMBER_ROLES.includes(groupRole);

export const isInvitedMember = ({ groupRole }: GroupMember): boolean => INVITED_MEMBER_ROLES.includes(groupRole);

/**
 * When displaying an event within the group context, we want to display
 * the event as "invited" even if the user is actually a departee or has
 * no actual event role.
 */
export const convertGroupEventRole = (event: EventV2): EventV2 => {
	const clone = cloneDeep(event);
	switch (clone.membershipRole) {
	case UserRole.DEPARTEE:
	case UserRole.EXTERNAL_INVITEE:
	case UserRole.NONE:
		clone.membershipRole = UserRole.INVITEE;
		break;
	default:
		break;
	}
	return clone;
};
